function notesDialogStepsAfterSave(noteStatus) {
  const status = Number(noteStatus);
  if (!(status >= 200 && status < 300)) return ['keep-open'];
  return ['close-dialog', 'write-local-cache'];
}

module.exports = {
  notesDialogStepsAfterSave,
};
